import styled from 'styled-components'
import media from 'styled-media-query'
import { TranslateLink } from 'gatsby-plugin-translate'
import { KeyboardArrowRight } from '@styled-icons/material-rounded'

export const MenuItem = styled.li`
  display: ${props => (props.visible ? 'none' : 'flex')};
  align-items: center;
  list-style-type: none;
  line-height: 2.6;

  ${media.lessThan('medium')`
    position: static;

    &:last-of-type {
      margin-bottom: 8rem;
    }
  `}
  &:hover {
    background-color: rgba(22, 22, 22, 0.04);
  }
`

export const MenuItemFavorites = styled.li`
  font-size: 20px;
  line-height: 24px;
  font-weight: 900;
  padding: 0 0;
  &:hover {
    background-color: rgba(22, 22, 22, 0.04);
  }
`

export const MenuLinkFavorites = styled(TranslateLink)`
  display: block;
  width: 100%;
  color: ${props => props.theme.menu.text};
  font-size: 16px;
  text-decoration: none;
  padding: 14px 2.4rem;
`

export const MenuLink = styled(TranslateLink)`
  display: block;
  width: 100%;
  color: ${props => props.theme.menu.text};
  font-size: 16px;
  text-decoration: none;
  padding: 14px 2.4rem;
`

export const SubmenuTitle = styled.p`
  margin: 0;
  color: ${props => props.theme.menu.text};
  font-size: 16px;
  font-family: ${props => props.theme.font};
  cursor: pointer;
  padding: 14px 2.4rem;
`

export const ArrowRightIcon = styled(KeyboardArrowRight)`
  color: ${props => props.theme.menu.text};
  cursor: pointer;
`
